import { render } from "./Checkbox.vue?vue&type=template&id=71756f8e"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71756f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71756f8e', __exports__)) {
    api.reload('71756f8e', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=71756f8e", () => {
    api.rerender('71756f8e', render)
  })

}


export default __exports__